module["exports"] = [
  "id",
  "title",
  "name",
  "email",
  "phone",
  "token",
  "group",
  "category",
  "password",
  "comment",
  "avatar",
  "status",
  "createdAt",
  "updatedAt"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/database/column.js
// module id = 376
// module chunks = 0